module.exports = __webpack_public_path__ + "99d034b6ce.png";